<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <select-component
            :class="`col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3`"
            :isMultiple="false"
            :dataOptions="farms"
            :requireClass="`required-farm`"
            :labelSelect="`${$t('common_words.farm')}: *`"
            :initialSelection="farm_id"
            @onChange="handleFilterChange"
            modelName="farm_id"
          />
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <br class="media-none" />
            <label>{{ $t('common_words.date') }}: *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              :picker-options="pickerOptions"
              class="shadow-sm required-date"
              v-model="date_sel"
              value-format="yyyy-MM-dd"
              :placeholder="`${$t('common_words.select2')}...`"
            />
          </div>
          <div class="col-12 col-md-4 col-xl-2">
            <br class="media-none" />
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button
              wide
              type="info"
              class="btn-filter"
              @click="validateFilter"
            >
              {{ $t('common_words.filter') }}
            </l-button>
          </div>
        </div>
        <br />
      </card>
      <card
        v-if="cutting"
        class="custom-shadow-card-header"
        :title="$t('production.harvested_kilograms')"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <table
              aria-describedby="tabla-cosechados"
              class="table table-striped table-bordered"
              v-if="cuttingForm.nCutting > 0"
            >
              <thead>
                <tr class="cusmtom-thead-color">
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '200px' }"
                  >
                    <strong>{{ $t('common_words.allotment') }}</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '200px' }"
                  >
                    <strong>{{ $t('common_words.variety') }}</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '150px' }"
                  >
                    <strong>{{ $t('common_words.area_roamed') }} (ha)</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '150px' }"
                  >
                    <strong>{{ $t('common_words.gross_weight') }} (Kg)</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '150px' }"
                  >
                    <strong>{{ $t('common_words.net_weight') }} (Kg)</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '100px', marginTop: '6px' }"
                  >
                    <strong>{{ $t('common_words.options') }}</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(_, index) in cuttingForm.nCutting" :key="index">
                  <td class="text-center">
                    <select-component
                      :class="`mt-3 col-12`"
                      :isMultiple="false"
                      :dataOptions="lots"
                      :requireClass="`required-cutting_lot`"
                      :initialSelection="cuttingForm.lots_sel[index]"
                      :indexSelect="index"
                      @onChange="handleFormChange"
                      modelName="lots_sel"
                    />
                  </td>
                  <td class="text-center">
                    <select-component
                      :class="`mt-3 col-12`"
                      :isMultiple="false"
                      :dataOptions="cropVarieties"
                      :requireClass="`required-crop_variety`"
                      :initialSelection="cuttingForm.crop_varieties_sel[index]"
                      :indexSelect="index"
                      @onChange="handleFormChange"
                      modelName="crop_varieties_sel"
                    />
                  </td>
                  <td class="text-center">
                    <fg-input
                      type="number"
                      step="0.1"
                      class="m-3 text-center input-covered_area"
                      v-model="cuttingForm.covered_area[index]"
                      :name="`common_words.area_roamed_${index}`"
                      v-validate="modelValidations.area_roamed"
                      :error="
                        getFieldErrorByIndex(
                          'common_words.area_roamed',
                          true,
                          index
                        )
                      "
                    />
                  </td>
                  <td class="text-center">
                    <fg-input
                      type="number"
                      step="0.1"
                      class="m-3 text-center input-gross_weight required-gross_weight"
                      v-model="cuttingForm.gross_weight[index]"
                      :name="`common_words.gross_weight_${index}`"
                      v-validate="modelValidations.gross_weight"
                      :error="
                        getFieldErrorByIndex(
                          'common_words.gross_weight',
                          true,
                          index
                        )
                      "
                    />
                  </td>
                  <td class="text-center">
                    <fg-input
                      type="number"
                      step="0.1"
                      class="m-3 text-center input-net_weight required-net_weight"
                      v-model="cuttingForm.net_weight[index]"
                      :name="`common_words.net_weight_${index}`"
                      v-validate="modelValidations.net_weight(index)"
                      :error="
                        getFieldErrorByIndex(
                          'common_words.net_weight',
                          true,
                          index
                        )
                      "
                    />
                  </td>
                  <td
                    class="text-center"
                    style="display: table-cell"
                    v-bind:style="{ width: '100px' }"
                  >
                    <div class="d-flex justify-content-center mt-3">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.add')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click.prevent="addLotData()"
                      >
                        <em class="fa fa-plus custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="cuttingForm.nCutting > 1 && isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(index)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr class="text-center">
                  <td colspan="3" class="text-muted text-center">
                    <strong>{{ $t('common_words.total_mayus') }}</strong>
                  </td>
                  <td>{{ totalGrossWeight }}</td>
                  <td>{{ totalNetWeight }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_module') }}
            </h5>
          </div>
          <div class="row">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                v-on:click="save('cutting')"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="deleteCuttingDetails()"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
      <card
        class="custom-shadow-card-header"
        v-if="cutting"
        :title="$t('production.rejected_kilograms')"
      >
        <div class="mt-4">
          <div
            class="row"
            style="overflow-x: auto"
            v-if="isIndex() && (isCreate() || isUpdate())"
          >
            <table
              style="width: 100%; white-space: nowrap"
              aria-describedby="tabla-recusados"
              class="table table-striped table-bordered"
              v-if="rejectionsForm.nCuttingRejections > 0"
            >
              <thead>
                <tr class="cusmtom-thead-color">
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '150px' }"
                  >
                    <strong>{{ $t('common_words.allotment') }}</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '150px' }"
                  >
                    <strong>{{ $t('production.rejection_motive') }}</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '200px' }"
                  >
                    <strong>{{ $t('common_words.weight') }} (Kg)</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '100px', marginTop: '6px' }"
                  >
                    <strong>{{ $t('common_words.options') }}</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(_, indexR) in rejectionsForm.nCuttingRejections"
                  :key="indexR"
                >
                  <td class="text-center">
                    <select-component
                      :class="`mt-3 col-12`"
                      :isMultiple="false"
                      :dataOptions="availableRejectionsLots"
                      :requireClass="`required-rejection_lot`"
                      :initialSelection="
                        rejectionsForm.lots_rejections_sel[indexR]
                      "
                      :indexSelect="indexR"
                      @onChange="handleFormChange"
                      modelName="rejection_lot"
                    />
                  </td>
                  <td class="text-center">
                    <select-component
                      :class="`mt-3 col-12`"
                      :isMultiple="false"
                      :dataOptions="rejections"
                      :requireClass="`required-rejection`"
                      :initialSelection="rejectionsForm.rejections_sel[indexR]"
                      :indexSelect="indexR"
                      @onChange="handleFormChange"
                      modelName="rejection"
                    />
                  </td>
                  <td class="text-center">
                    <fg-input
                      type="number"
                      step="0.1"
                      class="m-3 text-center input-rejection_weight required-rejection_weight"
                      v-model="rejectionsForm.weight[indexR]"
                      :name="`common_words.weight_${indexR}`"
                      v-validate="modelValidations.rejection_weight"
                      :error="
                        getFieldErrorByIndex(
                          'common_words.weight',
                          true,
                          indexR
                        )
                      "
                    />
                  </td>
                  <td
                    class="text-center"
                    style="display: table-cell"
                    v-bind:style="{ width: '100px' }"
                  >
                    <div class="d-flex justify-content-center mt-3">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.add')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click.prevent="addLotRejectionsData()"
                      >
                        <em class="fa fa-plus custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="
                          rejectionsForm.nCuttingRejections > 1 && isDelete()
                        "
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleRejectionsDelete(indexR)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr class="text-center">
                  <td colspan="2" class="text-muted text-center">
                    <strong>{{ $t('common_words.total_mayus') }}</strong>
                  </td>

                  <td>{{ totalRejectionWeight }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_module') }}
            </h5>
          </div>
          <div class="row">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                v-on:click="save()"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="deleteRejectionDetails()"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
      <div class="row">
        <div
          class="col-12 text-center"
          v-if="cutting && (isCreate() || isUpdate())"
        >
          <l-button wide type="info" class="btn-filter m-4" v-on:click="save()">
            {{ $t('common_words.save_all') }}
          </l-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { Validator } from 'vee-validate';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  mixins: [MixinPermissions, mixinMasters, MixinMenu, MixinForm],
  data() {
    return {
      farm_id: null,
      date_sel: null,
      user_id: this.$store.state.auth.user.id,
      fruit_harvest_header_id: null,
      has_details: false,
      has_rejections: false,

      cuttingForm: {
        lots_sel: [],
        crop_varieties_sel: [],
        covered_area: [],
        gross_weight: [],
        net_weight: [],
        nCutting: 1,
      },
      rejectionsForm: {
        lots_rejections_sel: [],
        rejections_sel: [],
        weight: [],
        nCuttingRejections: 1,
      },
      modelValidations: {
        gross_weight: {
          required: true,
          max: 6,
          min_value: 0,
          decimal: 2,
        },
        net_weight: (index) => ({
          required: true,
          max: 6,
          min_value: 0,
          decimal: 2,
          net_weight_lt_gross_weight: {
            grossWeight: this.cuttingForm.gross_weight[index],
          },
        }),
        area_roamed: {
          max: 6,
          min_value: 0,
          decimal: 2,
        },
        rejection_weight: {
          required: true,
          max: 6,
          min_value: 0,
          decimal: 2,
        },
      },

      relationLotRejections: [],
      cutting: false,
      isCuttingSave: false,
      isRejectionSave: true,
      farms: [],
      cropVarieties: [],
      lots: [],
      rejections: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    availableLots() {
      return this.lots.filter(
        (lot) => !this.cuttingForm.lots_sel.includes(lot.id)
      );
    },

    availableRejectionsLots() {
      return this.lots.filter((lot) =>
        this.cuttingForm.lots_sel.includes(lot.id)
      );
    },

    getGrossWeight(index) {
      return this.cuttingForm.gross_weight[index] || 0;
    },

    totalGrossWeight() {
      const total = this.cuttingForm.gross_weight.reduce(
        (sum, weight) => sum + Number(weight),
        0
      );

      return parseFloat(total.toFixed(2));
    },

    totalNetWeight() {
      const total = this.cuttingForm.net_weight.reduce(
        (sum, weight) => sum + Number(weight),
        0
      );

      return parseFloat(total.toFixed(2));
    },

    totalRejectionWeight() {
      const total = this.rejectionsForm.weight.reduce(
        (sum, weight) => sum + Number(weight),
        0
      );

      return parseFloat(total.toFixed(2));
    },
  },

  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    cleanForm() {
      this.relationLotRejections = [];
      this.fruit_harvest_header_id = null;

      this.cuttingForm.lots_sel = [];
      this.cuttingForm.crop_varieties_sel = [];
      this.cuttingForm.covered_area = [];
      this.cuttingForm.gross_weight = [];
      this.cuttingForm.net_weight = [];
      this.cuttingForm.nCutting = 1;
    },

    cleanRejectionsForm() {
      this.fruit_harvest_header_id = null;
      this.relationLotRejections = [];

      this.rejectionsForm.lots_rejections_sel = [];
      this.rejectionsForm.rejections_sel = [];
      this.rejectionsForm.weight = [];
      this.rejectionsForm.nCuttingRejections = 1;
    },

    handleFilterChange(data) {
      this.$set(this, data.name, data.selects);
    },

    handleFormChange(data) {
      try {
        switch (data.name) {
          case 'lots_sel':
            if (Array.isArray(this.cuttingForm.lots_sel)) {
              this.$set(this.cuttingForm.lots_sel, data.index, data.selects);
            }
            break;

          case 'crop_varieties_sel':
            if (Array.isArray(this.cuttingForm.crop_varieties_sel)) {
              this.$set(
                this.cuttingForm.crop_varieties_sel,
                data.index,
                data.selects
              );
            }
            break;

          case 'rejection_lot':
            if (Array.isArray(this.rejectionsForm.lots_rejections_sel)) {
              this.$set(
                this.rejectionsForm.lots_rejections_sel,
                data.index,
                data.selects
              );
            }
            break;

          case 'rejection':
            if (Array.isArray(this.rejectionsForm.rejections_sel)) {
              this.$set(
                this.rejectionsForm.rejections_sel,
                data.index,
                data.selects
              );
            }
            break;

          default:
            console.warn(
              `El nombre de campo ${data.name} no está siendo manejado en el objeto.`
            );
            break;
        }
      } catch (error) {
        console.error(error.message);
      }
    },

    validateFilter() {
      this.$validator
        .validateAll({
          farm_id: this.farm_id,
          date_sel: this.date_sel,
        })
        .then(() => {
          if (!isset(this.farm_id)) {
            return this.validationInputsRequired('farm');
          } else if (!isset(this.date_sel)) {
            return this.validationInputsRequired('date');
          } else {
            this.loadCuttings();
            this.cleanForm();
            this.cleanRejectionsForm();

            return true;
          }
        });
    },

    validateCutting() {
      return new Promise((resolve, reject) => {
        this.showHideLoading(true);
        this.$validator
          .validateAll({
            lots_sel: this.cuttingForm.lots_sel,
            crop_varieties_sel: this.cuttingForm.crop_varieties_sel,
            gross_weight: this.cuttingForm.gross_weight,
            net_weight: this.cuttingForm.net_weight,
          })
          .then(() => {
            for (let i = 0; i < this.cuttingForm.nCutting; i++) {
              if (!isset(this.cuttingForm.lots_sel[i])) {
                this.validationInputsRequired(`cutting_lot`);

                reject(false);
              } else if (!isset(this.cuttingForm.crop_varieties_sel[i])) {
                this.validationInputsRequired(`crop_variety`);

                reject(false);
              } else if (
                !isset(this.cuttingForm.gross_weight[i]) ||
                this.cuttingForm.gross_weight[i] < 0
              ) {
                this.validationInputsRequired(`gross_weight`);

                reject(false);
              } else if (
                !isset(this.cuttingForm.net_weight[i]) ||
                this.cuttingForm.net_weight[i] < 0
              ) {
                this.validationInputsRequired(`net_weight`);

                reject(false);
              } else if (
                Number(this.cuttingForm.gross_weight[i]) <=
                Number(this.cuttingForm.net_weight[i])
              ) {
                this.validationInputsRequired(`net_weight`);

                reject(false);
              }
            }
            this.showHideLoading();

            resolve(true);
          })
          .catch(() => {
            this.showHideLoading();

            reject(false);
          });
      });
    },

    validateRejectionCutting() {
      return new Promise((resolve, reject) => {
        this.showHideLoading(true);
        this.$validator
          .validateAll({
            lots_rejections_sel: this.rejectionsForm.lots_rejections_sel,
            rejections_sel: this.rejectionsForm.rejections_sel,
            rejection_weight: this.rejectionsForm.weight,
          })
          .then(() => {
            for (let i = 0; i < this.rejectionsForm.nCuttingRejections; i++) {
              if (!isset(this.rejectionsForm.lots_rejections_sel[i])) {
                this.validationInputsRequired(`rejection_lot`);

                reject(false);
              } else if (!isset(this.rejectionsForm.rejections_sel[i])) {
                this.validationInputsRequired(`rejection`);

                reject(false);
              } else if (
                !isset(this.rejectionsForm.weight[i]) ||
                this.rejectionsForm.weight[i] < 0
              ) {
                this.validationInputsRequired(`rejection_weight`);

                reject(false);
              }
            }
            this.showHideLoading();

            resolve(true);
          })
          .catch(() => {
            this.showHideLoading();

            reject(false);
          });
      });
    },

    addLotData() {
      this.cuttingForm.nCutting++;
    },

    addLotRejectionsData() {
      this.rejectionsForm.nCuttingRejections++;
    },

    handleDelete(lotIndex) {
      this.cuttingForm.nCutting--;
      const fieldsToRemove = [
        'lots_sel',
        'crop_varieties_sel',
        'covered_area',
        'gross_weight',
        'net_weight',
      ];

      fieldsToRemove.forEach((field) => {
        this.removeFromData(this.cuttingForm, field, lotIndex);
      });
    },

    handleRejectionsDelete(lotIndexR) {
      this.rejectionsForm.nCuttingRejections--;
      const fieldsToRemove = [
        'lots_rejections_sel',
        'rejections_sel',
        'weight',
      ];

      fieldsToRemove.forEach((field) => {
        this.removeFromData(this.rejectionsForm, field, lotIndexR);
      });
    },

    removeFromData(form, field, index) {
      try {
        if (!Array.isArray(form[field])) {
          console.warn(
            `El campo ${field} no es un array válido en el formulario.`
          );
          return;
        }
        const updatedField = form[field].filter((_, i) => i !== index);
        this.$set(form, field, updatedField);
      } catch (error) {
        console.error(`Error al actualizar ${field}: `, error);
      }
    },

    async saveCutting(savingIndividually = true) {
      const data = {
        route: 'cutting/fruits',
        expected_details_count: this.cuttingForm.nCutting,
        farm_id: this.farm_id,
        date_save: this.date_sel,
        user_id: this.user_id,
        details: this.cuttingForm.lots_sel.map((lotId, index) => ({
          lot_id: lotId,
          crop_variety_id: this.cuttingForm.crop_varieties_sel[index],
          covered_area: this.cuttingForm.covered_area[index] || 0,
          gross_weight: this.cuttingForm.gross_weight[index] || 0,
          net_weight: this.cuttingForm.net_weight[index] || 0,
        })),
      };

      this.showHideLoading(true);
      await Axios.postMasters(data)
        .then((response) => {
          this.showHideLoading();
          if (savingIndividually) {
            this.cleanForm();
            this.cutting = false;
            SweetAlert.success(response.data.message);
          }
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error);
        });
    },

    saveRejection(savingIndividually = true) {
      const data = {
        route: 'cutting/fruits/rejections',
        farm_id: this.farm_id,
        date_save: this.date_sel,
        user_id: this.user_id,
        details: this.rejectionsForm.lots_rejections_sel.map(
          (lotId, index) => ({
            lot_id: lotId,
            rejection_reason_id: this.rejectionsForm.rejections_sel[index] || 0,
            weight: this.rejectionsForm.weight[index] || 0,
          })
        ),
      };

      this.showHideLoading(true);
      Axios.postMasters(data)
        .then((response) => {
          this.showHideLoading();
          if (savingIndividually) {
            this.cleanRejectionsForm();
            this.cutting = false;
            SweetAlert.success(response.data.message);
          }
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error);
        });
    },

    save(option = 'both') {
      try {
        this.validateCutting().then((isValidCutting) => {
          if (isValidCutting) {
            if (option === 'cutting') {
              if (isValidCutting) {
                this.saveCutting();
                this.cleanAll();
              }
            } else if (option === 'rejection') {
              this.validateRejectionCutting().then((isValidRejections) => {
                if (isValidRejections) {
                  this.saveRejection();
                  this.cleanAll();
                }
              });
            } else if (option === 'both') {
              this.validateRejectionCutting().then((isValidRejections) => {
                if (isValidRejections) {
                  Promise.all([
                    this.saveCutting(false),
                    this.saveRejection(false),
                  ]).then(() => {
                    SweetAlert.success(
                      i18n.t('production.data_saved_successfully')
                    );
                    this.cleanAll();
                  });
                }
              });
            }
          }
        });
      } catch (error) {
        console.error('Error al guardar:', error);
      }
    },

    cleanAll() {
      this.cleanForm();
      this.cleanRejectionsForm();
      this.cutting = false;
    },

    loadCuttings() {
      this.showHideLoading(true);

      Promise.all([
        Axios.getMasters(`farms/farms/lots/${this.farm_id}`),
        Axios.getMasters(`cutting/fruits/${this.date_sel}/${this.farm_id}`),
        Axios.getMasters(
          `cutting/fruits/rejections/${this.date_sel}/${this.farm_id}`
        ),
      ])
        .then(([lotsResponse, cuttingResponse, cuttingRejectionResponse]) => {
          this.lots = lotsResponse.data.data;

          const cuttingRes = cuttingResponse.data.data;
          if (
            cuttingRes &&
            cuttingRes.lots_sel &&
            cuttingRes.lots_sel.length > 0
          ) {
            this.has_details = true;
            this.fruit_harvest_header_id = cuttingRes.header_id;
            this.cuttingForm = {
              ...this.cuttingForm,
              lots_sel: cuttingRes.lots_sel,
              crop_varieties_sel: cuttingRes.crop_varieties_sel,
              covered_area: cuttingRes.covered_area,
              gross_weight: cuttingRes.gross_weight,
              net_weight: cuttingRes.net_weight,
              nCutting: cuttingRes.lots_sel.length,
            };
          }

          const cuttingRejectionRes = cuttingRejectionResponse.data.data;
          if (
            cuttingRejectionRes &&
            cuttingRejectionRes.lots_rejections_sel &&
            cuttingRejectionRes.lots_rejections_sel.length > 0
          ) {
            this.has_rejections = true;
            this.fruit_harvest_header_id = cuttingRes.header_id;
            this.rejectionsForm = {
              ...this.rejectionsForm,
              lots_rejections_sel: cuttingRejectionRes.lots_rejections_sel,
              rejections_sel: cuttingRejectionRes.rejections_sel,
              weight: cuttingRejectionRes.weight,
              nCuttingRejections:
                cuttingRejectionRes.lots_rejections_sel.length,
            };
          }

          this.showHideLoading();
          this.cutting = true;
        })
        .catch((error) => {
          this.cutting = true;
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    deleteCuttingDetails() {
      if (this.has_details) {
        SweetAlert.delete(i18n.t('production.capture_details')).then(
          (result) => {
            if (result.value) {
              let data = {
                id: this.fruit_harvest_header_id,
                route: `cutting/fruits/delete`,
              };
              Axios.destroyMaster(data)
                .then((response) => {
                  this.showHideLoading();
                  this.cleanForm();
                  this.cutting = false;
                  SweetAlert.success(response.data.message);
                })
                .catch((error) => SweetAlert.warning(error));
            }
          }
        );
      } else {
        SweetAlert.warning(i18n.t('production.no_record_to_delete'));
      }
    },

    deleteRejectionDetails() {
      if (this.has_rejections) {
        SweetAlert.delete(i18n.t('production.rejected_details')).then(
          (result) => {
            if (result.value) {
              let data = {
                id: this.fruit_harvest_header_id,
                route: `cutting/fruits/rejections/delete`,
              };
              Axios.destroyMaster(data)
                .then((response) => {
                  this.showHideLoading();
                  this.cleanForm();
                  this.cutting = false;
                  SweetAlert.success(response.data.message);
                })
                .catch((error) => SweetAlert.warning(error));
            }
          }
        );
      } else {
        SweetAlert.warning(i18n.t('production.no_record_to_delete'));
      }
    },
  },

  created() {
    // Registrar la regla personalizada
    Validator.extend('net_weight_lt_gross_weight', {
      validate: (value, { grossWeight }) => {
        return parseFloat(value) < parseFloat(grossWeight);
      },
      getMessage: (fieldName, params) =>
        i18n.t('production.net_weight_lt_gross_weight_validation', {
          fieldName,
          grossWeight: params.grossWeight,
        }),
      params: ['grossWeight'],
    });

    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('farms/farms/onlycapturefruit')
        .then((response) => {
          this.farms = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });

      Axios.getMasters('cropvarieties')
        .then((response) => {
          this.cropVarieties = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });

      Axios.getMasters('rejecteds/causes')
        .then((response) => {
          this.rejections = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('cutting');
  },

  destroyed() {
    this.deselectedItemOnMenu('cutting');
  },
};
</script>
<style>
.card .table:not(.not-last-td) thead th:last-child {
  display: revert !important;
}
</style>
